module.exports = __webpack_public_path__ + "static/media/v8.e2de8c6e.mp4";